import React from 'react';
import Modal from './Modal';

interface DeleteModelProp {
  imageUrl: string;
  show: boolean;
  onClose: () => void;
}

const ImagePreviewModel: React.FC<DeleteModelProp> = ({
  onClose,
  show,
  imageUrl,
}) => {
  return (
    <>
      <Modal show={show} onClose={onClose} height="max-h-[400px]" size="w-lg">
        <div className="w-full h-[80%] transition-all group-hover:scale-110 duration-300">
          <img
            src={`${imageUrl}`}
            alt=""
            className="object-contain w-full h-full inset-0"
          />
        </div>
      </Modal>
    </>
  );
};

export default ImagePreviewModel;
